import { apiRequest, API_BASE_URL } from './api';
import { Document } from '../store/document/types';
/**
 * Get the URL to fetch a document file
 * @param documentId The ID of the document
 * @returns The URL to fetch the document file
 */
export const getDocumentFileUrl = (documentId?: string): string => {
  if (!documentId) return '#';
  return `${API_BASE_URL}/documents/${documentId}/file`;
};

/**
 * Get a direct URL for a document (useful for PDFs that need to be loaded in iframes)
 * @param document The document object
 * @returns A Promise that resolves to the direct URL
 */
export const getDirectDocumentUrl = async (document: Document): Promise<string> => {
  try {
    // If the document link is a Supabase URL, we need to get a signed URL through the API
    if (
      document.link &&
      (document.link.includes('supabase') || document.link.includes('localhost'))
    ) {
      const response = await apiRequest<{ url: string }>(`/documents/${document.id}/direct-link`);
      return response.url;
    }

    // If it's an external URL, return it directly
    if (document.link) {
      return document.link;
    }

    // Fallback to the file endpoint
    return getDocumentFileUrl(document.id);
  } catch (error) {
    console.error('Error getting direct document URL:', error);
    // Fallback to the file endpoint
    return getDocumentFileUrl(document.id);
  }
};

/**
 * Fetch a document by ID
 * @param documentId The ID of the document
 * @returns The document data
 */
export const fetchDocument = async (documentId: string): Promise<Document> => {
  return apiRequest<Document>(`/documents/${documentId}`);
};
